import { Route, Routes } from "react-router-dom";
import Loader from "../../components/Loader";
import { useInvoiceV2Flag } from "./hooks/useInvoiceV2Flag";

// Tab containers
import InvoiceManagementV1 from "./index";
import InvoiceManagementV2 from "./v2";

// PO detail page — two versions, gate picks one
import InvoiceDetails from "./InvoiceDetails";     // pure v1
import InvoiceDetailsV2 from "./InvoiceDetailsV2"; // v2 with batch upload

// Shared pages (same for both flows)
import AddEditInvoice from "./AddEditInvoice";
import CreditNoteSubmission from "./CreditNoteSubmission";
import PostUpload from "./PostUpload";
import RevisedPOReview from "./RevisedPOReview";

// V2-only pages
import EditInvoiceV2 from "./v2/pages/EditInvoice";
import InvoiceDetailV2 from "./v2/pages/InvoiceDetail";

import RfqGate from "../Rfq/RfqGate";
import RfqDetail from "../Rfq/RfqDetail";

export default function InvoiceManagementGate({ user }) {
  const { isV2, isLoading } = useInvoiceV2Flag();

  if (isLoading) return <Loader />;

  return (
    <Routes>
      {/* Tab container — v2 or v1 */}
      <Route index element={isV2 ? <InvoiceManagementV2 /> : <InvoiceManagementV1 />} />

      {/* PO detail page — v2 or v1 */}
      <Route
        path=":po_code"
        element={isV2 ? <InvoiceDetailsV2 user={user} /> : <InvoiceDetails user={user} />}
      />

      {/* Shared pages — same for both flows */}
      <Route path=":po_code/edit" element={<AddEditInvoice user={user} />} />
      <Route path="post-upload" element={<PostUpload user={user} />} />
      <Route path="po/:po_code/revision" element={<RevisedPOReview user={user} />} />
      <Route path="po/:po_code/credit-note" element={<CreditNoteSubmission user={user} />} />

      {/* V2-only routes — individual invoice detail + edit */}
      {isV2 && <Route path="v2/:invoiceId" element={<InvoiceDetailV2 />} />}
      {isV2 && <Route path="v2/:invoiceId/edit" element={<EditInvoiceV2 />} />}
      {isV2 && <Route path="rfqs/:rfqId" element={<RfqGate><RfqDetail /></RfqGate>} />}

    </Routes>
  );
}
